import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

const navLinkClass = ({ isActive }) =>
  `text-sm font-medium transition-colors ${isActive ? "text-[var(--primary)]" : "text-[var(--text-muted)] hover:text-[var(--primary)]"}`;

export default function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[var(--bg)]/90 backdrop-blur border-b border-[var(--border)]">
      <div className="max-w-5xl mx-auto px-6 sm:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="font-serif-display text-2xl text-[var(--primary)]">
          Feelique
        </Link>
        <nav className="hidden sm:flex items-center gap-8">
          <NavLink to="/" end className={navLinkClass}>Home</NavLink>
          <NavLink to="/moodscape" className={navLinkClass}>Moodscape</NavLink>
          <NavLink to="/feedback" className={navLinkClass}>Feedback</NavLink>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:inline text-sm text-[var(--text-muted)]">{user.name}</span>
              <Button
                variant="ghost"
                className="text-sm"
                onClick={() => { logout(); navigate("/"); }}
              >
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" className="text-sm" onClick={() => navigate("/auth")}>
                Sign in
              </Button>
              <Button
                className="rounded-full bg-[var(--primary)] hover:bg-[var(--primary-hover)] text-white"
                onClick={() => navigate("/auth?mode=register")}
              >
                Start Now
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
